<template>
    <el-dialog width="504px"
               :visible.sync="isShow"
               :title="`${isEditMode ? '修改' : '新增'}属性`"
               top="82px"
               append-to-body
               :close-on-click-modal="false">
        <el-form :model="formData" label-width="100px" ref="form">
            <el-form-item label="属性名称" prop="name" :rules="[{required: true, message: '请输入属性名称', trigger: 'blur'}, {validator: formatAttrName, trigger: 'blur'}]">
                <el-input :style="{width: '268px'}" v-model="formData.name" placeholder="请输入属性名称"
                          maxlength="50" @focus="showTip = true" @blur="showTip = false"
                ></el-input>
                <el-checkbox v-model="formData.isRequired" :style="{marginLeft: '20px'}">必选</el-checkbox>
                <p :style="{fontSize: '12px', color: '#999999', lineHeight: '24px'}" v-if="showTip">输入值小于50位，只允许字母、数字、下划线的字符组合；输入以字母开头</p>
            </el-form-item>
            <el-form-item label="数据类型" prop="propertyType" required>
                <el-select v-model="formData.propertyType" size="small" @change="changeType">
                    <el-option :key="0" label="int(整数)" :value="0"></el-option>
                    <el-option :key="1" label="decimal(小数)" :value="1"></el-option>
                    <el-option :key="2" label="string(字符串)" :value="2"></el-option>
                    <el-option :key="3" label="jsonObject(JSON结构体)" :value="3"></el-option>
                    <el-option :key="4" label="dateTime(日期时间)" :value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="访问权限" prop="access" :rules="[{required: true}, {validator: validAccess, trigger: 'change'}]">
                <el-checkbox v-model="readable" @change="produceAccess">可读</el-checkbox>
                <el-checkbox v-model="writable" @change="produceAccess">可写</el-checkbox>
            </el-form-item>
            <el-form-item label="取值范围" required key="value" v-if="formData.propertyType === 0 ||formData.propertyType === 1">
               <div :style="{width: '336px'}">
                   <el-col :span="11">
                       <el-form-item prop="minValue" :rules="[{required: true, message: '请输入取值范围', trigger: 'blur'}, {validator: formatMinValue, trigger: 'blur'}]">
                           <el-input v-model="formData.minValue" maxlength="10"></el-input>
                       </el-form-item>
                   </el-col>
                   <el-col class="line" :span="2" :style="{textAlign: 'center'}">-</el-col>
                   <el-col :span="11">
                       <el-form-item prop="maxValue" :rules="[{required: true, message: '请输入取值范围', trigger: 'blur'}, {validator: formatMaxValue, trigger: 'blur'}]">
                           <el-input v-model="formData.maxValue" maxlength="10"></el-input>
                       </el-form-item>
                   </el-col>
               </div>
            </el-form-item>
            <el-form-item label="步长" prop="stepLength" key="stepLength"
                          v-if="formData.propertyType === 0 ||formData.propertyType === 1"
                          :rules="{validator: formatStepLength, trigger: 'blur'}"
            >
                <el-input :style="{width: '336px'}" v-model="formData.stepLength" placeholder="请输入步长" maxlength="2"></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="unit" key="unit" v-if="formData.propertyType === 0 ||formData.propertyType === 1">
                <el-input :style="{width: '336px'}" v-model="formData.unit" placeholder="请输入单位" maxlength="16"></el-input>
            </el-form-item>
            <el-form-item label="长度" prop="length" key="length" v-if="formData.propertyType === 2 || formData.propertyType === 3 || formData.propertyType === 4"
                          :rules="[{required: true, message: '请输入长度', trigger: 'blur'}, {validator: formatLength, trigger: 'blur'}]">
                <el-input :style="{width: '336px'}" v-model="formData.length" placeholder="请输入长度" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="枚举值" prop="enum" key="enum" v-if="formData.propertyType === 2" :rules="{validator: formatEnum, trigger: 'change'}">
                <div :style="{width: '336px'}">
                    <el-input v-model="formData.enum" type="textarea"
                              :rows="3"
                              maxlength="1024"></el-input>
                </div>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button plain size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm" :style="{marginLeft: '24px'}">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {isServiceId, isServiceId2, isNumber, isDynamicNumber, isEnum} from "../../assets/js/utils";

    export default {
        name: "editAttributeDialog",
        data() {
            return {
                isShow: false,
                isEditMode: false,
                productId: null,
                serveId: null,
                names: [],
                formData: {
                    id: '',
                    name: '',
                    isRequired: false,
                    access: 0,
                    propertyType: 0,
                    maxValue: 65535,
                    minValue: 0,
                    stepLength: 1,
                    unit: '',
                    length: 1,
                    enum: '',
                },
                readable: false,
                writable: false,
                resolve: null,
                showTip: false,
            }
        },
        watch: {
            isShow(v) {
                if (!v) {
                    this.resolve && this.resolve(null)
                    this.resolve = null
                    this.$refs.form.clearValidate();
                }
            },
        },
        methods: {
            validAccess(rule, value, callback) {
                if (!value) {
                    callback(new Error('访问权限不能为空'))
                }
                callback()
            },
            formatLength(rule, value, callback) {
                if (!isNumber(value)) {
                    callback(new Error('长度格式不正确'))
                    return;
                }
                let v = Number(value);
                if (v >= 2147483647 || v <= 0) {
                    callback(new Error('长度为大于0，小于2147483647的数字'))
                    return;
                }
                callback();
            },
            formatStepLength(rule, value, callback) {
                if (!isNumber(value)) {
                    callback(new Error('步长格式不正确'))
                    return;
                }
                let v = Number(value);
                if (v >= 50 || v <= 0) {
                    callback(new Error('步长为大于0，小于50的数字'))
                    return;
                }
                callback();
            },
            formatMinValue(rule, value, callback) {
                if (!isDynamicNumber(value)) {
                    callback(new Error('数字格式不正确'))
                    return;
                }
                let v = Number(value);
                if (v > 2147483647) {
                    callback(new Error('输入值不能大于2147483647'))
                    return;
                }

                if (v < -2147483647) {
                    callback(new Error('输入值不能小于2147483647'))
                    return;
                }

                if (isDynamicNumber(this.formData.maxValue)) {
                    let maxV = Number(this.formData.maxValue);
                    if (v > maxV) {
                        callback(new Error('最小值不能大于最大值'));
                        return;
                    }
                }
                // this.$refs.form.validateField('maxValue');

                callback();
            },
            formatMaxValue(rule, value, callback) {
                if (!isDynamicNumber(value)) {
                    callback(new Error('数字格式不正确'))
                    return;
                }
                let v = Number(value);
                if (v > 2147483647) {
                    callback(new Error('数字不能大于2147483647'))
                    return;
                }

                if (v < -2147483647) {
                    callback(new Error('数字不能小于2147483647'))
                    return;
                }
                if (isDynamicNumber(this.formData.minValue)) {
                    let minV = Number(this.formData.minValue);
                    if (v < minV) {
                        callback(new Error('最大值不能小于最小值'));
                        return;
                    }
                }
                // this.$refs.form.validateField('minValue');
                callback();
            },
            formatAttrName(rule, value, callback) {
                if (!isServiceId2(value)) {
                    callback(new Error('属性名称必须以字母开头'))
                    return
                }
                if (!isServiceId(value)) {
                    callback(new Error('属性名称只允许字母、数字、下划线、连字符的字符组合'))
                    return
                }
                if (this.names.includes(value)) {
                    callback(new Error('属性名称重复'))
                    return
                }
                callback()
            },
            formatEnum(rule, value, callback) {
                if (!value) {
                    callback();
                    return;
                }
                if (!isEnum(value)) {
                    callback(new Error('枚举值仅允许输入字母，单词间使用英文逗号符分隔'))
                    return
                }
                callback()
            },
            initData () {
                this.productId= null;
                this.serveId = null;
                this.showTip = false;
                this.formData = {
                    id: '',
                    name: '',
                    isRequired: false,
                    access: 0,
                    propertyType: 0,
                    maxValue: 65535,
                    minValue: 0,
                    stepLength: 1,
                    unit: '',
                    length: 1,
                    enum: '',
                }
                this.readable= false
                this.writable=false
                this.resolve=null
            },
            changeType(v) {},
            produceAccess() {
                if (!this.readable && !this.writable) {
                    this.formData.access = 0;
                } else if (!this.readable && this.writable) {
                    this.formData.access = 2;
                } else if (this.readable && !this.writable) {
                    this.formData.access = 1;
                } else {
                    this.formData.access = 3;
                }
            },
            fromAccess() {
                if (this.formData.access === 0) {
                    this.readable = false;
                    this.writable = false;
                } else if (this.formData.access === 1) {
                    this.readable = true;
                    this.writable = false;
                } else if (this.formData.access === 2) {
                    this.readable = false;
                    this.writable = true;
                } else {
                    this.readable = true;
                    this.writable = true;
                }
            },
            async show(data, names = []) {
                this.isEditMode = data && data.id;
                this.initData();
                this.names = names;
                if (data) {
                    this.formData = data;
                    this.fromAccess();
                }
                this.isShow = true;
                return new Promise(resolve => {
                    this.resolve = resolve
                })
            },
            cancel() {
                this.resolve && this.resolve(null);
                this.resolve = null;
                this.isShow = false;
            },
            async confirm() {
                await this.$refs.form.validate();
                this.produceAccess()
                this.resolve && this.resolve(this.formData);
                this.isShow = false;
            },
        }
    }
</script>

<style scoped>
    .btns{
        text-align: center;
        padding-top: 15px;
    }
</style>